var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.666 4c0-.368.299-.667.667-.667H14a.667.667 0 0 1 0 1.334H5.333A.667.667 0 0 1 4.666 4ZM4.666 8c0-.368.299-.667.667-.667H14a.667.667 0 0 1 0 1.334H5.333A.667.667 0 0 1 4.666 8ZM4.666 12c0-.368.299-.667.667-.667H14a.667.667 0 1 1 0 1.334H5.333A.667.667 0 0 1 4.666 12ZM1.333 4c0-.368.298-.667.667-.667h.006a.667.667 0 0 1 0 1.334H2A.667.667 0 0 1 1.333 4ZM1.333 8c0-.368.298-.667.667-.667h.006a.667.667 0 0 1 0 1.334H2A.667.667 0 0 1 1.333 8ZM1.333 12c0-.368.298-.667.667-.667h.006a.667.667 0 1 1 0 1.334H2A.667.667 0 0 1 1.333 12Z"
  })));
};

export default SvgHamburger;